import { Component, OnInit, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, } from '@angular/core';
import { ComponentInteractionService } from 'src/app/services/navbar.service';
import { WindowRef } from '../../../services/window.service';
import { AuthService } from '../../../services/auth.service';
import urlLink from '../../../life-config/apiEndPoints.json';
import { Observable } from 'rxjs';
import { SharedApiService} from '../../../services/shared-api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class MenuComponent implements OnInit {
    // elem = null;
    // isLoggedIn$: Observable<boolean>;
    // amsurl = '';
    // public sidenav: any;
    // toggleActive = false;
    // amsURlInfo: any = urlLink['apiEndPoints']['amsURL'];
    isAppActivated: string;
    // tslint:disable-next-line: ban-types
    source: Boolean= false;
    constructor(
        private CmpIntActionService: ComponentInteractionService,
        public win: WindowRef,
        private auth: AuthService,
        private sharedData: SharedApiService,
        private activatedRoute: ActivatedRoute) {

        

            const getQueryParams = this.activatedRoute.snapshot.queryParams;
            const isSourceApp = getQueryParams['source'];
            const fromLocalStorage = localStorage.getItem('isSource');
            if (isSourceApp &&  isSourceApp.length > 1 ) {
                this.source  = true;
                localStorage.setItem('isSource', 'app');
            } 

            if (fromLocalStorage && fromLocalStorage.length > 1) {

                this.source  = true;

            }
    }   







    // Invoking  hamburger menu

    // invokeSidenav() {
    //     this.toggleActive = !this.toggleActive;
    //     this.CmpIntActionService.toggle();
    // }

    // tslint:disable-next-line: member-ordering
    // @ViewChild('widgetId', { static: true }) widgetId: ElementRef;

    ngOnInit() {
        // this.isLoggedIn$ = this.auth.isLoggedIn;



        // tslint:disable-next-line: no-unused-expression
        // new this.win.nativeWindow.RB_AMS_SDK({
        //     // userInfo: this.elem,
        //     islogIn: this.auth.setUser,
        //     UserlogOut: this.auth.logOut,
        //     amsurl: this.amsURlInfo,
        //     loginBoxStyle1: true,
        //     widgetColor: '#ef663c',
        //     widgetFont: '14px'
        // });

    }

}
